import { Pagination } from '../Pagination'
import type { UseCollectionResult } from './useCollection'

export interface CollectionPaginationProps<RowT> {
  collection: UseCollectionResult<RowT>
  perPageOptions?: number[]
  jump?: boolean | 'auto'
  firstLast?: boolean
  alwaysShowRange?: boolean
  className?: string
}

export function CollectionPagination<RowT>({ collection, perPageOptions = [10, 25, 50, 100], jump = 'auto', firstLast = false, alwaysShowRange = false, className = '' }: CollectionPaginationProps<RowT>) {
  return (
    <Pagination
      page={collection.page.page}
      totalPages={collection.page.totalPages}
      from={collection.page.from}
      to={collection.page.to}
      total={collection.page.total}
      onPageChange={collection.setPage}
      perPage={collection.page.pageSize}
      onPerPageChange={collection.setPageSize}
      perPageOptions={perPageOptions}
      jump={jump}
      firstLast={firstLast}
      alwaysShowRange={alwaysShowRange}
      className={className}
    />
  )
}
